<template>
  <div>
    <v-icon @click="dialog = true" color="orange">mdi-pencil</v-icon>

    <SysDialog
      v-model="dialog"
      :titulo="'Editar o modulo: ' + editar_item.id + ' - ' + editar_item.descricao"
      txtBotao="Atualizar"
      @click:primary="editarSubMenu()"
    >
      <Form
        :item="editar_item"
        :dialog="dialog"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import Form from './Includes/_form.vue';
import { editarSubMenusConfiguracaoMenuParametrizacao } from '../../Api';

export default {
  components: {
    SysDialog,
    Form
  },
  model: {
    prop: 'editar_item',
    event: 'change-editar'
  },
  props: {
    editar_item: {
      type: Object
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    fecharDialog() {
      this.dialog = false;
    },
    editarSubMenu() {
      this.$store.dispatch(
        'loading/addRequisicao',
        editarSubMenusConfiguracaoMenuParametrizacao(this.editar_item)
          .then(() => this.$emit('atualizar-tela-inicial-menu-configuracao-sub-menu'))
          .catch(() => this.Helpers.logout())
          .finally(() => this.fecharDialog())
        );
    },
  }
}
</script>

<style>

</style>
